module.exports = __webpack_public_path__ + "static/media/practiceranking_active.4c78b54a.svg";